module.exports = {
    DOC_PREFIX : '/braintree/docs',
    ARTICLES_PREFIX : '/braintree/articles',
    HELP_PREFIX : '/braintree/help',
    BT_PREFIX : '/braintree',
    ART_PREFIX : '/articles',
    HE_PREFIX : '/help',
    ASSET_URL: process.env.ASSET_URL ? process.env.ASSET_URL : '/',
    REQUEST_TITLE_SEPARATOR: '%%%',
    REQUIRED_REQUEST_TITLE_SEPARATOR: ':',
    NO_INDEX:true
}